export const SBBOL_REDIRECT_KEY = 'SBBOL_REDIRECT';
export const SBBOL_MESSAGE = 'SBBOL_BINDING_SUCCESS';
